import { ADD_BOOKING, REMOVE_BOOKING } from "./actionTypes"

export const addBooking = (data) => {
    return {
        type: ADD_BOOKING,
        payload: data
    }
}

export const removeBooking = (id) => {
    return {
        type: REMOVE_BOOKING,
        payload: id
    }
}